<template>
  <article class="project project-writing padded">
    <section class=" project-section ">
      <h1>Writing</h1>
      <p>
        I love reading, and wanting to write something which some. I have been
        putting it off for a long time - with various excuses. The last two
        years I tried to put some writings in the open even though I wasn't
        completely satisfied with it.
      </p>
      <p>
        My writing is faaar off from how I want it to be, and 2021 is the year I
        wish to dedicate to improving my writing and storytelling skills.
      </p>
    </section>
    <section class="project-section nav-list">
      <h2>Few writings I am satisfied with</h2>
      <dl>
        <div v-for="blog in blogs" :key="blog.name" class="nav-list__header">
          <dt class="text">
            <a :href="blog.link" target="_blank" rel="noopener noreferrer">{{
              blog.name
            }}</a>
          </dt>
          <dd class="nav-list__description">{{ blog.description }}</dd>
        </div>
      </dl>
    </section>
    <section class="project-section ">
      <p>
        More on
        <a
          href="https://medium.com/@Poulami"
          target="_blank"
          rel="noopener noreferrer"
          >Medium</a
        >
        and
        <a
          href="https://dev.to/poulamic"
          target="_blank"
          rel="noopener noreferrer"
          >Dev</a
        >
      </p>
    </section>
    <section class="project-section notepad">
      <p>
        One of the main issues I face when I sit down to write is getting bogged
        down by details and writing style. A method (and tool) which works for
        me is a writing pad which forces me to dump my thoughts without getting
        distracted by editing
      </p>
      <p>
        You can try the technique here - continue writing for
        <input
          type="number"
          value="5"
          v-model="sessionTime"
          :disabled="editorActive"
        />
        minutes to not lose your work
      </p>
      <transition name="fade">
        <section class="notepad__output" v-if="attemptFailed">
          <p>Sorry, you stopped writing before reaching set goal.</p>
          <button @click="attemptFailed = !attemptFailed">Try Again</button>
        </section>
        <text-box
          class="notepad__textarea"
          :session-time="sessionTime"
          v-if="!attemptFailed"
          @emitfailure="attemptFailed = !attemptFailed"
          @editor-active="editorActive = true"
        />
      </transition>
    </section>
  </article>
</template>

<script>
import TextBox from '../childComps/TextBox.vue'
import { Blogs } from '@/contents/contents.js'
export default {
  components: { TextBox },
  data() {
    return {
      blogs: Blogs,
      sessionTime: 5,
      editorActive: false,
      attemptFailed: false
    }
  }
}
</script>

<style scoped>
.notepad__output {
  margin-top: 3.6rem;
}
.notepad__output {
  margin-bottom: 50vh;
}
.nav-list__description {
  font-family: var(--header-font);
}
.nav-list__header + .nav-list__header,
.notepad__textarea {
  margin-top: 1.2rem;
}
</style>
